import React from "react";
import { Box, Typography } from "@material-ui/core";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { DPErrorMessage } from "Components/DP";
import { AnomalyReportHeader } from "./AnomalyReportHeader/AnomalyReportHeader";
import { PayrollAnomalyDetails } from "./PayrollAnomalyDetails/PayrollAnomalyDetails";
import { EmployeeAnomaliesTable } from "./EmployeeAnomaliesTable/EmployeeAnomaliesTable";
import { DownloadReportButton } from "./DownloadReportButton/DownloadReportButton";
import { usePayrollAnomalyDetails } from "./usePayrollAnomalyDetails";
import useStyles from "./styles";
import { useRouter } from "Hooks/useRouter";

export const AnomalyReport = () => {
  const classes = useStyles();
  const { match } = useRouter();
  const { id: netEarningsFileId } = match.params as { id: string };

  const { payrollAnomalyDetails, loading } = usePayrollAnomalyDetails(netEarningsFileId);

  if (loading) {
    return null;
  }

  if (!payrollAnomalyDetails?.supportsAnomalyReport || !payrollAnomalyDetails.anomalyReport) {
    return (
      <DPErrorMessage />
    );
  }

  return (
    <div>
      <div className={classes.headerWrapper}>
        <AnomalyReportHeader title="Payroll Anomaly Report" />
        <DownloadReportButton netEarningsFileId={netEarningsFileId} />
      </div>
      <Box m={6} mt={4}>
        <HelpText>
          <b>What is the Payroll Anomaly Report?</b>
          <br />
          This report summarizes file information and net pay statistics from your payroll journal.
          Employee earnings that have deviated from previous payroll journals are displayed here
          to provide context about changes in employee earnings.
          <br />
          <b>This report is informational and will not interrupt the presettlement process
            for employee payments.</b>
        </HelpText>
        <PayrollAnomalyDetails fileDetails={payrollAnomalyDetails}/>
        <Typography className={classes.title} variant="h3">
          ANOMALOUS EARNINGS
        </Typography>
        <EmployeeAnomaliesTable netEarningsFileId={netEarningsFileId} />
      </Box>
    </div>
  );
};
